export {
    IsAndroid,
    IsIOS,
    IsMobile,
    IsIPhoneSafari,
    IsFirefox,
    IsIE11,
    IsIE11Win7,
    GoFullscreen,
    ShouldGoFullscreen,
    ShouldGoFullscreenScroll,
    ShouldPreventScroll,
    PreventScroll,
    UseSimulatedScrolling,
    AddScroll,
    ClearMemory,
    SetLowPowerMode,
    IsLowPowerModeEnabled,
} from './DeviceUtils';
